import { Service } from '@roc/feature-app-core';

export const PC_STATUS_CLEARED = 'ACCEPTED';
export const isPcConditionOpen = (status: string) =>
  !['ACCEPTED', 'NOT_APPLICABLE'].includes(status);

const url = {
  ADD_POST_CLOSING_CONDITION: '/api/v1/taskV2/addPostClosingCondition',
  UPDATE_POST_CLOSING_CONDITION: '/api/v1/taskV2/updatePostClosingCondition',
  HAS_OPEN_CONDITIONS: '/api/v1/taskV2/hasOpenPostClosingConditions',
};

export class PostClosingConditionService extends Service {
  createCondition(taskId: number, level: number, reason: string, isInternal: boolean = false) {
    return this.post(`${url.ADD_POST_CLOSING_CONDITION}?isInternal=${isInternal}`, { taskId, level, reason });
  }

  resolveCondition(taskId: number, accepted: boolean, comment?: string) {
    return this.post(url.UPDATE_POST_CLOSING_CONDITION, { taskId, accepted, comment, manualChange: true });
  }

  hasOpenConditions(loanId: number) {
    return this.get(url.HAS_OPEN_CONDITIONS, { loanId });
  }
}
